import callPhoneNumber from "./callPhoneNumber"

export default callPhoneNumber
